// Font-family mapping per language code. Falls back to system serif.
// Loaded via <link rel="stylesheet" ...> in public/index.html (Google Fonts Noto).
export const LANGUAGE_FONT = {
  hi: "'Noto Sans Devanagari', 'Mangal', serif",
  mr: "'Noto Sans Devanagari', 'Mangal', serif",
  bn: "'Noto Sans Bengali', 'Vrinda', serif",
  ta: "'Noto Sans Tamil', 'Latha', serif",
  te: "'Noto Sans Telugu', 'Gautami', serif",
  kn: "'Noto Sans Kannada', 'Tunga', serif",
  ml: "'Noto Sans Malayalam', 'Kartika', serif",
  gu: "'Noto Sans Gujarati', 'Shruti', serif",
  pa: "'Noto Sans Gurmukhi', 'Raavi', serif",
  ur: "'Noto Naskh Arabic', 'Urdu Typesetting', serif",
  ar: "'Noto Naskh Arabic', 'Geeza Pro', serif",
  zh: "'Noto Sans SC', 'PingFang SC', serif",
  ja: "'Noto Sans JP', 'Hiragino Sans', serif",
  ko: "'Noto Sans KR', 'Apple SD Gothic Neo', serif",
  ru: "'Noto Sans', 'Helvetica', serif",
  // Latin scripts fall back to the default editor serif
};

export const RTL_LANGUAGES = new Set(["ur", "ar"]);

// Codes whose native script is NOT Latin. Used to decide when to show the
// "Convert to native script" button in the chapter editor.
export const NON_LATIN_LANGUAGES = new Set(Object.keys(LANGUAGE_FONT));

export function isNonLatin(code) {
  return NON_LATIN_LANGUAGES.has(code);
}

export function fontFamilyForLanguage(code) {
  return LANGUAGE_FONT[code] || "'Cormorant Garamond', Georgia, serif";
}

export function isRTL(code) {
  return RTL_LANGUAGES.has(code);
}
